import { render, staticRenderFns } from "./WarnList.vue?vue&type=template&id=79971f16&scoped=true"
import script from "./WarnList.vue?vue&type=script&lang=js"
export * from "./WarnList.vue?vue&type=script&lang=js"
import style0 from "./WarnList.vue?vue&type=style&index=0&id=79971f16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79971f16",
  null
  
)

export default component.exports